export default __webpack_public_path__ + "static/media/slider.fb3b7015.svg";